class CompositeAccessRule {
  rules;
  operator;
  constructor(rules, operator) {
    this.rules = rules;
    this.operator = operator;
  }
  validate(value) {
    const result = this.rules.length === 0 || this.operator === "and" && this.rules.every((rule) => rule.validate(value)) || this.operator === "or" && this.rules.some((rule) => rule.validate(value));
    return result;
  }
  toString() {
    const operator = this.operator.toUpperCase();
    return this.rules.map((rule) => `(${rule.toString()})`).join(` ${operator} `);
  }
}
export {
  CompositeAccessRule
};
//# sourceMappingURL=CompositeAccessRule.js.map
